import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const putAlertSupplierConfimationreadCountSlice = createApi(`PutAlertSupplierConfimationreadCountSlice`,"POST");

const PutAlertSupplierConfimationreadCountSlice = createSlice({
  name: 'PutAlertSupplierConfimationreadCountSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putAlertSupplierConfimationreadCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putAlertSupplierConfimationreadCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putAlertSupplierConfimationreadCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PutAlertSupplierConfimationreadCountSlice.reducer;